import React from "react"
import { AlertTriangle as Icon } from "react-feather"

import style from "./Maintenance.module.scss"

export const Maintenance: React.FunctionComponent = () => {
  return (
    <div className={`${style.maintenancePage}`} id="maintenance">
      <div className={style.icon}>
        <Icon aria-hidden="true" />
      </div>
      <h1 className={style.title}>Banca CF+ è in manutenzione</h1>
      <p className={style.text}>L&apos;applicazione non è disponibile al momento, tornerà online a breve</p>
      <a href="https://www.bancacfplus.it/contatti/" className={style.cta}>
        Contattaci
      </a>
    </div>
  )
}
